import React from "react";
import PropTypes from "prop-types";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { InputBase } from "@mui/material";
import {
  createSearchBoxStyle,
  fontFamily,
  passwordRegex,
  reviewScreenButtonWithColor,
  reviewScreenButtonWithOutColor,
} from "../Constants/constants";

export default function AdminUpdatePasswordModal({ show, handleClose, onSave, editingData }) {
  //
  const [email, setEmail] = React.useState(""); // New state variable for email
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setconfirmPassword] = React.useState("");

  // Check if password meets all requirements
  const isPasswordValid = () => {
    return passwordRegex.test(password) && password === confirmPassword && password.length > 0;
  };

  const handleSaveClick = () => {
    if (!passwordRegex.test(password)) {
      alert(
        "Password must be 8+ characters with an uppercase letter, a number, and a special character."
      );
      return;
    }
    if (password !== confirmPassword) {
      alert("Passwords do not match!");
      return;
    }

    const newRow = {
      id: Date.now(),
      email,
      password,
      confirmPassword,
    };
    onSave(newRow);
  };
  // Do not prefill email when opening the modal
  React.useEffect(() => {
    if (editingData) {
      console.log("🔐 Reset Password - editingData:", editingData);
      setEmail(editingData.email || editingData);
      setPassword("");
      setconfirmPassword("");
    }
  }, [editingData]);

  return (
    <Modal
      open={show}
      onClose={(event, reason) => {
        // Prevent closing on backdrop click or escape key
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        handleClose();
      }}
      aria-labelledby="add-administrator-modal-title"
      aria-describedby="add-administrator-modal-description"
    >
      <div
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
          width: "460px",
          padding: "20px",
          outline: "none",
          backgroundColor: "white",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
        }}
      >
        <span style={{ color: "#2aa7e0", fontFamily: fontFamily, fontWeight: 400, fontSize: 22 }}>
          Reset Password
          {editingData?.firstName && editingData?.lastName
            ? ` for ${editingData.firstName} ${editingData.lastName}`
            : ""}
        </span>
        <div
          style={{
            height: "1px",
            width: "100%",
            backgroundColor: "#2aa7e0",
            marginBottom: "20px",
          }}
        ></div>
        <form
          autoComplete="off"
          style={{ width: "100%", maxWidth: "460px" }}
          onSubmit={(e) => {
            e.preventDefault();
            handleSaveClick();
          }}
        >
          {/* Hidden fields to prevent browser password manager autofill */}
          <input
            type="text"
            name="prevent_autofill"
            value=""
            style={{ display: "none" }}
            tabIndex={-1}
            aria-hidden="true"
          />
          <input
            type="password"
            name="prevent_autofill_pass"
            value=""
            style={{ display: "none" }}
            tabIndex={-1}
            aria-hidden="true"
          />
          <div>
            {/* Email field */}
            <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
              <span
                style={{
                  color: "black",
                  display: "inline-block",
                  width: "160px",
                  minWidth: "160px",
                  fontFamily: fontFamily,
                }}
              >
                Email
              </span>
              <InputBase
                style={createSearchBoxStyle({ width: "250px", height: "36px" })}
                inputProps={{
                  "aria-label": "Email",
                  style: { padding: "0 8px" },
                }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled
              />
            </div>

            {/* Password field */}
            <div style={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    color: "black",
                    display: "inline-block",
                    width: "160px",
                    minWidth: "160px",
                    fontFamily: fontFamily,
                  }}
                >
                  Password
                </span>
                <InputBase
                  style={createSearchBoxStyle({ width: "250px", height: "36px" })}
                  inputProps={{
                    "aria-label": "Password",
                    style: { padding: "0 8px" },
                    autoComplete: "one-time-code",
                  }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  name="new-password"
                  autoComplete="one-time-code"
                />
              </div>
              {/* Password Requirements (show only after typing) */}
              {password.length > 0 && (
                <div
                  style={{
                    marginLeft: "180px",
                    marginTop: "5px",
                    fontSize: "12px",
                    color: "#666",
                  }}
                >
                  <div style={{ marginBottom: "2px" }}>Password must contain:</div>
                  <div style={{ color: password.length >= 8 ? "#4caf50" : "#f44336" }}>
                    ✓ At least 8 characters {password.length >= 8 ? "✓" : "✗"}
                  </div>
                  <div style={{ color: /[A-Z]/.test(password) ? "#4caf50" : "#f44336" }}>
                    ✓ One uppercase letter {/[A-Z]/.test(password) ? "✓" : "✗"}
                  </div>
                  <div style={{ color: /[0-9]/.test(password) ? "#4caf50" : "#f44336" }}>
                    ✓ One number {/[0-9]/.test(password) ? "✓" : "✗"}
                  </div>
                  <div
                    style={{
                      color: /[!@#$%^&*]/.test(password) ? "#4caf50" : "#f44336",
                    }}
                  >
                    ✓ One special character (!@#$%^&*)
                    {/[!@#$%^&*]/.test(password) ? " ✓" : " ✗"}
                  </div>
                </div>
              )}
            </div>

            {/* Confirm Password field */}
            <div style={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    color: "black",
                    display: "inline-block",
                    width: "160px",
                    minWidth: "160px",
                    fontFamily: fontFamily,
                    whiteSpace: "nowrap",
                  }}
                >
                  Confirm Password
                </span>
                <InputBase
                  style={createSearchBoxStyle({ width: "250px", height: "36px" })}
                  inputProps={{
                    "aria-label": "Confirm Password",
                    style: { padding: "0 8px" },
                    autoComplete: "one-time-code",
                  }}
                  value={confirmPassword}
                  onChange={(e) => setconfirmPassword(e.target.value)}
                  type="password"
                  name="confirm-new-password"
                  autoComplete="one-time-code"
                />
              </div>
              {/* Password Match Indicator */}
              {confirmPassword.length > 0 && (
                <div
                  style={{
                    marginLeft: "180px",
                    marginTop: "5px",
                    fontSize: "12px",
                    color: password === confirmPassword ? "#4caf50" : "#f44336",
                  }}
                >
                  {password === confirmPassword ? "✓ Passwords match" : "✗ Passwords do not match"}
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: 20,
              }}
            >
              <Button
                variant="contained"
                style={reviewScreenButtonWithOutColor(100)}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                style={{
                  ...reviewScreenButtonWithColor(100),
                  opacity: isPasswordValid() ? 1 : 0.5,
                  cursor: isPasswordValid() ? "pointer" : "not-allowed",
                  backgroundColor: isPasswordValid() ? undefined : "#ccc",
                }}
                onClick={handleSaveClick}
                disabled={!isPasswordValid()}
              >
                Save
              </Button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

AdminUpdatePasswordModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  editingData: PropTypes.func.isRequired,
};
